import * as React from "react"
import {Grid, Skeleton} from "@mui/material";
import {generateArrayByNumber} from "@ui-seeker/utils";


export default function RepricingAlertsLoadingBlock() {
	return <>
		{ generateArrayByNumber(8).map(n => <Grid item xs={3} key={n}>
			<Skeleton variant="rectangular" width="100%" height={280} />
		</Grid>)}
	</>
}